<template>
  <!-- <nav>
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </nav> -->
  <router-view />
</template>
<style scoped src="@/style.css"></style>
<script>
import { store } from '@/store';
import { provideI18n, replaceLangugeTextDeep } from '@/js/i18n';
import { SystemLangGet } from '@/js/api/system';
import en from '@/i18n/en.json';
import zhtw from '@/i18n/zhtw.json';
import cn from '@/i18n/cn.json';
// import de from '@/i18n/de.json';
// import th from '@/i18n/th.json';
// import fr from '@/i18n/fr.json';

export default {
  setup() {
    let systemLangLoaded = false;
    const messages = {
      zhtw,
      cn,
      en,
      // de,
      // th,
      // fr,
    };

    /**
     * 檢查語系欄位並取得值
     * @param data
     * @param fields
     */
    function getLangField(data, fields) {
      const field = fields.find((fieldName) => data[fieldName] != null);
      return field === undefined ? undefined : data[field];
    }

    /**
     * 套用系統語系更新
     * @param updates
     */
    const applySystemLangUpdates = (updates) => {
      if (!Array.isArray(updates)) return;

      updates.forEach((element) => {
        const rawKey = getLangField(element, ['LANG_KEY', 'lang_key', 'key']);
        const rawLocale = getLangField(element, ['LANG_LOCALE', 'lang_locale', 'locale']);
        const value = getLangField(element, ['LANG_VALUE', 'lang_value', 'value']);

        if (!rawKey || value === undefined || value === null) return;

        const keyParts = rawKey.split('.');
        const localeFromKey = messages[keyParts[0]] ? keyParts.shift() : '';
        const localeKey = rawLocale || localeFromKey;
        const targetMessages = messages[localeKey];
        const langKey = keyParts.join('.');

        if (!targetMessages || !langKey) return;

        replaceLangugeTextDeep(targetMessages, langKey, value);
      });
    };

    /** 載入系統語系更新 */
    const loadSystemLangUpdates = async () => {
      if (systemLangLoaded) return;

      try {
        const res = await SystemLangGet();
        if (res.data.success) {
          applySystemLangUpdates(res.data.result);
          systemLangLoaded = true;
        }
      } catch {
        applySystemLangUpdates([]);
      }
    };

    let locale = 'zhtw';
    if (sessionStorage.getItem('setLang')) {
      locale = sessionStorage.getItem('setLang');
      store.commit('setLang', locale);
    } else {
      store.commit('setLang', locale);
    }

    // TODO:待確認有API再測試
    // const updates = [
    //   { key: 'zhtw.SysMenu.As_1', value: '階層設定' },
    //   { key: 'zhtw.SysMenu.As_2', value: '商業區' },
    // ];

    // updates.forEach((element) => {
    //   replaceLangugeTextDeep(zhtw, element.key, element.value);
    // });

    provideI18n({
      locale,
      messages,
    });

    loadSystemLangUpdates();
  },
};
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  // color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
